export const TicketsStatus: any = {
    PENDING: "На рассмотрении",
    IN_PROGRESS: "В процессе",
    COMPLETED: "Выполнено",
    REJECTED: "Откланено",
};
